module.exports = __webpack_public_path__ + "static/media/0016.fe3cbfea.jpg";